
import React from "react";
import { Link } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
//import Button from 'components/buttons/';
function ContentsContainer() {
	return (
		<PageContainer session={false}>
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">개인정보처리방침</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="member-join">
						<h1 className="tx tx-hd2">개인정보처리방침</h1>
						<div className="fw-policy">
							<div className="top-box">
								대·중소기업·농어업협력재단(이하 "재단")에서 운영하는 "대·중소기업상생협력기금 종합관리시스템"은 귀하의 개인정보보호를 매우 중요시하며, 『정보통신망이용촉진등에관한법률』상의 개인정보보호 규정 및 정보통신부가 제정한 『개인정보보호지침』을 준수하고 있습니다. "재단"은 개인정보보호방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
							</div>

							<div className="fw-policy-cont">
								<p>
									"재단"은 귀하께서 회원가입 시 개인정보보호정책 또는 이용약관의 내용에 대해 「동의」버튼을 클릭할 수 있는 절차를 마련하여, 「동의합니다」버튼을
									클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.
								</p>
								<p>
									"재단"은 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다. 귀하가 "재단"의 서비스를 이용하기 위해서는 회원가입 시 희망
									아이디, 비밀번호, 성명, 이메일, 전화번호를 필수적으로 입력하셔야 합니다. 그러나 선택항목은 이를 입력하지 않더라도 서비스 이용에는 제한이 없습니다.
								</p>
								<p>개인정보 항목별 구체적인 수집목적 및 이용목적은 다음과 같습니다.</p>
								<p>
									- <strong>성명, 아이디, 비밀번호</strong> : 회원제 서비스 이용에 따른 본인 확인 절차에 이용<br/>
									- <strong>이메일, 전화번호</strong> : 고지사항 전달, 불만처리 등을 위한 원활한 의사소통 경로 확보, 새로운 서비스 및 이벤트 정보
									안내<br/>
									- <strong>기타 선택항목</strong> : 대·중소기업상생협력기금 관리시스템의 원활한 사용을 위해 부수적으로 필요한 정보
								</p>
								<p>
									귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보열람 및 정정을 하고자 할 경우에는 [마이페이지]를 클릭하여
									직접 열람 또는 정정하거나, 개인정보관리책임자에게 (서면, 전화, E-mail)로 연락하시면 즉시 조치하겠습니다. 귀하가 개인정보의 오류에 대한 정정을
									요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다.
									또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 조치하겠습니다.
									회원가입 등을 통해 이루어진 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회하실 수 있습니다.
									동의철회는 개인정보관리책임자에게 (서면, 전화, E- mail)로 연락하시면 즉시 개인정보의 삭제 등 필요한 조치를 취하겠습니다.
								</p>
								<p>
									수집된 개인정보의 보유기간은 회원가입 후 회원탈퇴시까지 입니다. 또한 탈퇴 시 "재단"은 회원님의 개인정보를 재생이 불가능한 방법으로 즉시 파기하며
									(개인정보가 제3자에게 제공된 경우에는 제3자에게도 파기하도록 지시합니다.) 다만, 다음 각 호의 경우에는 각 호에 명시한 기간 동안 개인정보를
									보유합니다.
								</p>
								<p>
									① 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간동안 거래내역과 최소한의 기본정보를 보유<br/>
									② 보유기간을 회원님에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 회원님의 동의를 받을 경우에는 약속한 보유기간 동안<br/>
									③ 계약 또는 청약철회 등에 관한 기록은 5년, 대금결제 및 재화 등의 공급에 관한 기록은 5년, 그리고 소비자의 불만 또는 분쟁처리에 관한 기록은
									3년 동안. 귀하의 동의를 받아 보유하고 있는 거래정보 등을 귀하께서 열람을 요구하는 경우 "재단"은 지체 없이 그 열람, 확인할 수 있도록 조치합니다
								</p>
								<p>
									"재단"은 귀하의 개인정보를 [개인정보의 수집목적 및 이용목적]에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타
									기업·기관에 제공하지 않습니다. 그러나 보다
									나은 서비스 제공을 위하여 귀하의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다. 개인 정보를 제공하거나 공유할 경우에는 사전에
									귀하께 제휴사가 누구인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지,
									그리고 언제까지 어떻게 보호·관리되는지에 대해 개별적으로 전자우편 및 서면을 통해 고지하여 동의를 구하는 절차를 거치게 되며, 귀하께서 동의하지 않는
									경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다.
								</p>
								<p>
									개인정보의 처리를 위탁하는 경우에는 위탁계약 등을 통하여 서비스제공자의 개인정보보호 관련지시 엄수, 개인정보에 관한 비밀유지, 제3자 제공의 금지 및
									사고시의 책임부담 등을 명확히 규정하고 당해 계약내용을 서면 또는 전자적으로 보관하겠습니다.
								</p>
								<p>"재단"은 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을
									강구하고 있습니다.</p>
								<p>
									① 귀하의 개인정보는 비밀번호에 의해 보호되며, 비밀번호는 암호알고리즘을 이용하여 안전하게 보호되고 있습니다.<br/>
									② 해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며,
									각 서버마다 침입탐지시스템을 설치하여 24시간 침입을 감시하고 있습니다.
								</p>
								<p>
									귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 "재단"은 개인정보보호 담당자를 두어 귀하의 개인 정보를 관리하고 있으며
									개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 운영하고 있습니다. 귀하의 개인정보와 관련한 문의사항 및 불만사항이 있으시면 아래의
									개인정보보호 담당자에게 연락 주시면 즉시 조치하여 처리결과를 통보하겠습니다.
								</p>
								<p>
									<strong>
										대중소기업상생협력기금 종합관리시스템<br/>
										개인정보 담당자 : 대·중소기업·농어업협력재단 상생기금부 김주경 차장 (kjk@win-win.or.kr, 02-368-8713)<br/>
										개인정보보호책임자 : 형준호 본부장<br/>
										소 속 : 대·중소기업·농어업협력재단·기획조정본부<br/>
									</strong>
								</p>
								<p>
									정보주체는 다음 각 호의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.
									개인정보보호위원회의 자체적인 개인정보 불만처리, 피해구제를 통해 해결되지 않으시거나 보다 자세한 도움이 필요하시면 아래의 기관으로 문의하여 주시기
									바랍니다.
								</p>
								<ul>
									<li>1. 개인정보 분쟁조정위원회
										<ul>
											<li>가. 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
											<li>나. 홈페이지 : <Link to="www.kopico.go.kr"
																target="_blank">www.kopico.go.kr</Link></li>
											<li>다. 전화 : (국번없이)1833-6972</li>
											<li>라. 주소 : (03171) 서울특별시 종로구 세종대로 209 정부서울청사 12층</li>
										</ul>
									</li>
									<li>2. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
										<ul>
											<li>가. 소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
											<li>나. 홈페이지 : <Link to="privacy.kisa.or.kr"
																target="_blank">privacy.kisa.or.kr</Link></li>
											<li>다. 전화 : (국번없이) 118</li>
										</ul>
									</li>
									<li>3. 대검찰청 사이버수사과 : (국번없이) 1301 ( <Link to="www.spo.go.kr"
																			 target="_blank">www.spo.go.kr</Link>)
									</li>
									<li>4. 경찰청 사이버안전국 : (국번없이) 182 ( <Link to="https://cyberbureau.police.go.kr"
																		   target="_blank">https://cyberbureau.police.go.kr</Link>)
									</li>
								</ul>
								<p>이 개인정보 처리방침은 2021년 4월 1일부터 적용됩니다.</p>
								<p>
									법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전에
									홈 페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다.
								</p>
							</div>
						</div>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}

export default ContentsContainer;